// extracted by mini-css-extract-plugin
module.exports = {"dragDropModal":"styles_dragDropModal__I7xUR","content":"styles_content__7OscY","date":"styles_date__aYg6Y","dateItem":"styles_dateItem__fFoz7"};